import {Link, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useWindowSize} from "../../../../hook/useWindowSize";
import {useMySearchParams} from "../../../../hook/useMySearchParams";
import SearchBox from "../../../components/general/searchBox";
import Icon from "../../../components/general/icon";
import Pagination from "../../../components/general/table/pagination";
import {useGetConditions} from "../../../../hook/request/condition";
import {ROUTES} from "../../../../constants";
import ConditionsTable from "../../../components/basicInformation/condition/dataList/conditionsTable";
import ConditionCardsBox from "../../../components/basicInformation/condition/dataList/conditionCardsBox";
import DeleteConditionModal from "../../../components/basicInformation/condition/deleteConditionModal";
import {useFindAccessInAccessList} from "../../../../constants/constant/accessProcess";

const dataListTitles = [
  "شرایط پزشکی",
  "توضیحات",
  "مکسا",
]

type TFilterValues = {
  pageNumber?: string;
  perPage?: string;
  search?: string;
}

const ConditionsList = () => {

  const [width] = useWindowSize();
  const {findAccessInAccessList} = useFindAccessInAccessList();
  const [searchParams] = useSearchParams();
  const { getQueryParams, updateSearchParams } = useMySearchParams();
  const [vaccinesData, setConditionsData] = useState([]);
  const [filterValues, setFilterValues] = useState<TFilterValues>({
    pageNumber: "0",
    perPage: "10",
    search: "",
  });

  // services
  const getConditionsRequest = useGetConditions(getQueryParams(filterValues));

  useEffect(() => {
    let _filterValues = {};
    _filterValues = {
      ...filterValues,
      pageNumber: searchParams.get("pageNumber") || "0",
      perPage: searchParams.get("perPage") || "10",
      search: searchParams.get("search") || "",
    }
    setFilterValues(_filterValues)
  }, [searchParams]);

  useEffect(() => {
    getConditionsRequest?.data?.data?.result &&
    setConditionsData(getConditionsRequest?.data?.data.result)
  }, [getConditionsRequest.data])

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {name, value} = e.target;
    updateSearchParams({
      pageNumber: "0",
      perPage: filterValues?.perPage,
      [name]: value,
    })
  }

  const doChangePage = (param: any) => {
    updateSearchParams({
      pageNumber: param?.index,
      perPage: filterValues?.perPage,
    })
  }

  return (
    <>
      <div className="card-box">
        <section className="filter-box d-flex flex-column flex-md-row mb-4">
          <div className="form-group ms-md-auto">
            <SearchBox
              name="search"
              value={filterValues?.search}
              onChange={handleFilterChange}
              placeholder="جستجوی شرایط پزشکی"
            />
          </div>
          {
            findAccessInAccessList('BASIC_MEDICAL_CONDITIONS') &&
            <div className="d-flex align-items-center align-items-stretch justify-content-center justify-content-md-start mb-3 m-md-0">
              <Link to={ROUTES.CONDITION_ADD.PATH} className="btn btn-primary rounded d-flex align-items-center fw-bold px-4">
                <span className="d-inline-flex font-25 ms-2 ps-2"><Icon name="add-square"/></span>
                افزودن شرایط پزشکی
              </Link>
            </div>
          }
        </section>

        <section className="table-cont table-responsive">
          {
            width < 900 ?
              <ConditionCardsBox
                dataList={vaccinesData}
                dataListTitles={dataListTitles}
                isRequesting={getConditionsRequest.isPending}
              /> :
              <ConditionsTable
                dataList={vaccinesData}
                dataListTitles={dataListTitles}
                isRequesting={getConditionsRequest.isPending}
              />
          }
          <Pagination
            paginationData={{...filterValues, ...vaccinesData}}
            doChangePage={doChangePage}
          />
        </section>
      </div>
      <DeleteConditionModal/>
    </>
  );
};

export default ConditionsList;